import { render, staticRenderFns } from "./SingleJournal.vue?vue&type=template&id=56028d32&scoped=true"
import script from "./SingleJournal.vue?vue&type=script&lang=js"
export * from "./SingleJournal.vue?vue&type=script&lang=js"
import style0 from "./SingleJournal.vue?vue&type=style&index=0&id=56028d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56028d32",
  null
  
)

export default component.exports